export const arcgisJSUrl = "https://js.arcgis.com/4.13/"
export const arcgisCSSUrl = "esri/themes/light/main.css"
export const arcgisGeocodeUrl = "https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer?sourceCountry=MYS"
export const iwkPrintServiceUrl = "https://igis.iwk.com.my/geoserver/rest/services/Production/PrintingServices/GPServer/Export%20Web%20Map"
export const publicSTPFormUrl = "https://igis.iwk.com.my/geoserver/rest/services/Production/STP/MapServer/31"
export const publicSTPAssetNumber = "IGISPROD.SDE.PUBLIC_STP.ASSET_NO"
export const publicSTPDescFuncLoc = "IGISPROD.sde.AMIS.LOCATION"
export const userDefinedRegionUrl = "https://igis.iwk.com.my/indahgeoportal/UserDefinedRegion/"
export const downloadableGISDataUrl = "https://igis.iwk.com.my/indahgeoportal/DownloadableGISData/"
export const stpDataUrl = "https://igis.iwk.com.my/indahgeoportal/STPData/"
export const serviceCatalogueUrl = "https://igis.iwk.com.my/indahgeoportal"
export const upiNegeriUrl = "https://mygos.mygeoportal.gov.my/gisserver/rest/services/UPI/UPI/MapServer/0/"
export const upiDaerahUrl = "https://mygos.mygeoportal.gov.my/gisserver/rest/services/UPI/UPI/MapServer/1/"
export const upiMukimUrl = "https://mygos.mygeoportal.gov.my/gisserver/rest/services/UPI/UPI/MapServer/2/"
export const upiSeksyenUrl = "https://mygos.mygeoportal.gov.my/gisserver/rest/services/UPI/UPI/MapServer/3/"
export const upiLotUrl = "https://igis.iwk.com.my/geoserver/rest/services/Production/Base/MapServer/25/"
export const restArcgis = "https://igis.iwk.com.my/geoserver/rest/services"
export const pipe_material = {
    "1":"ABS Plastic", "14": "Asbestos Cement", "2": "Cast Iron", "15": "Cured in Place Lining", "16": "Ductile Iron",
    "3":"Glass Reinforced Plastic", "8": "high Density Polyethylene", "6": "Mild Steel", "10": "Modified PVC", "9": "Polyester Resin Concrete",
    "5": "Reinforced Concrete", "12": "Salt Glazed Ware Pipe", "11": "Spiral Wound", "13": "Stainless Steel", "4": "Unplasticized Polyvinyl Chloride", "7": "Vitrified Clay"
}
export const diameter_mm = {
    "0": "UNKNOWN", "1": "100", "2": "110", "3": "150", "4": "200", "5": "225", "6": "230", "7": "250", "8": "255", "9": "300", "10": "305",
    "11": "315", "12": "350", "13": "375", "14": "380", "15": "400", "16": "450", "17": "460", "18": "500", "19": "525", "20": "600",
    "21": "650", "22": "675", "23": "700", "24": "750", "25": "900", "26": "975", "27": "1000", "28": "1050", "29": "1200", "30": "1350",
    "31": "1350", "32": "1500", "33": "1800", "34": "2100", "35": "2300", "36": "2500", "37": "2800", "999": "OTHERS"
}




// WEBPACK FOOTER //
// ./src/utilities/constants.js